import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { FaChevronDown } from 'react-icons/fa';

const Header = () => {
  // This state now controls the dropdown menu on mobile
  const [isNavOpen, setNavOpen] = useState(false);

  const [isServicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [isMarketsDropdownOpen, setMarketsDropdownOpen] = useState(false);



  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  return (
    // The 'nav-open' class will be added here to help style children if needed
    <header className={`header-container ${isNavOpen ? 'nav-open' : ''}`}>
      <div className="top-bar">
        <div className="logo-area">
          <button className="hamburger-menu" onClick={toggleNav}>
            &#9776; {/* The hamburger icon */}
          </button>
          <div className="logo">CRISHI - Crop Research & Intelligence Solutions #India</div>
        </div>
        
        <div className="header-actions">
          <a href="/" className="search-link">Search</a>
          <a href="https://crishi.agalabs.com/sign-in" className="login-btn">Login</a>
           <Link to="/signup">
            <button className="demo-btn">Demo</button>
          </Link>
        </div>
      </div>
      
      {/* The nav element itself is no longer the slide-out panel.
          The 'active' class will simply show/hide the 'ul' inside it. */}
      <nav className={`main-nav ${isNavOpen ? 'active' : ''}`}>
        <ul>
          <li 
            className="dropdown-container"
            onMouseEnter={() => setMarketsDropdownOpen(true)}
            onMouseLeave={() => setMarketsDropdownOpen(false)} // <-- FIX: ADDED onMouseLeave here
          >
            Markets<FaChevronDown className="dropdown-arrow" />
            
            {isMarketsDropdownOpen && (
              <ul className="dropdown-menu">
                <li><Link to="/markets">All markets</Link></li>
                <li><Link to="/markets/grains">Grains</Link></li>
                <li><Link to="/markets/oilseeds">Oilseeds</Link></li>
                <li><Link to="/markets/pulses">Pulses</Link></li>
                <li><Link to="/markets/spices">Spices</Link></li>
                <li><Link to="/markets/energy">Energy</Link></li>
              </ul>
            )}
          </li>

          <li 
            className="dropdown-container"
            onMouseEnter={() => setServicesDropdownOpen(true)} // Show dropdown on hover
            onMouseLeave={() => setServicesDropdownOpen(false)}
          >
            Services<FaChevronDown className="dropdown-arrow" />
            
            {/* The actual dropdown menu */}
            {isServicesDropdownOpen &&  (
              <ul className="dropdown-menu">
                <li><Link to="/prices">Prices & Indices</Link></li>
                <li><Link to="/futures">Futures</Link></li>
                <li><Link to="/insights">News & Insights</Link></li>
                <li><Link to="/data-statistics">Data & Statistics</Link></li>
                <li><Link to="/historical-data">Historical data</Link></li>
                <li><Link to="/reports">Reports</Link></li>
                <li><Link to="/tenders">Tenders</Link></li>
                <li><Link to="/consulting">Consulting</Link></li>
                <li><Link to="/forecasting">Forecasting</Link></li>
              </ul>
            )}
          </li>
          <li><a href="/Insights">News & Insights</a></li>
          <li><a href="/Events">Events</a></li>
          <li><a href="/">About us</a></li>
          <li><a href="/">Careers</a></li>
        </ul>
        
        {/* The Contact Us button is part of the desktop nav */}
        <a href="https://agalabs.com/contact-us" className="contact-btn">Contact us</a>
      </nav>
    </header>
  );
};

export default Header;